import { Grid, makeStyles, Typography } from '@material-ui/core';
import React, { useContext } from 'react';
import StoryContext from '../../contexts/StoryContext';
import ErrorBoundary from '../ErrorBoundary';
import MessageBox from '../MessageBox';
import SubquestionBox from '../SubquestionBox';
import ProvidersChangeSubsidies from './ProvidersChangeSubsidies';
import TotalNumberOfProvidersSubsidies from './TotalNumberOfProvidersSubsidies';

function StoryQ2A() {
  const { lightColor, darkColor } = useContext(StoryContext);

  const classes = makeStyles((theme) => ({
    title: {
      color: `${darkColor} !important`,
      textTransform: 'capitalize',
    },
    dataGrid: {
      marginTop: theme.spacing(2),
    },
  }))();

  return (
    <SubquestionBox color={lightColor}>

      <Grid
        spacing={2}
        container
        direction="row"
        justify="center"
        alignItems="center"
      >
        <Grid item xs={12}>
          <Typography variant="h4" component="h3" align="center" className={classes.title} gutterBottom>
            How has COVID-19 affected the supply of child care providers accepting subsidies?
          </Typography>
        </Grid>

        <Grid item xs={10} sm={7}>
          <MessageBox>
            <Typography variant="body1" align="left">
              <ErrorBoundary>
                <ProvidersChangeSubsidies />
              </ErrorBoundary>
            </Typography>
          </MessageBox>
        </Grid>
      </Grid>
      <Grid
        spacing={2}
        container
        direction="row"
        justify="center"
        alignItems="center"
        className={classes.dataGrid}
      >
        <Grid item xs={12} sm={6}>
          <ErrorBoundary>
            <TotalNumberOfProvidersSubsidies height={320} />
          </ErrorBoundary>
        </Grid>
      </Grid>
    </SubquestionBox>
  );
}

export default StoryQ2A;
